export default __webpack_public_path__ + "static/media/execute_examTypes.a49506e7.png";